












































































import { Component, Vue } from 'vue-property-decorator'
import Login from '../auth/LoginPage.vue'
import NotificationsList from '../notifications/List.vue'

@Component({
  components: {
    Login,
    NotificationsList
  }
})
export default class AuthenticatedWindow extends Vue {
  // private navbarTitle: string = `App.vue`;
  // private msg: string = `Mode=${VUE_APP_MODE} and Platform=${VUE_APP_PLATFORM}`;
  isLoggedIn = false;
  overlay = false;
  drawer = false;

  menu = [{
    path: '/main',
    icon: 'mdi-view-dashboard',
    label: 'Explore'
  },
  {
    path: '/portfolio',
    icon: 'mdi-wallet',
    label: 'Portfolio'
  },
  {
    path: '/account',
    icon: 'mdi-account',
    label: 'Account'
  },
  {
    path: '/contact',
    icon: 'mdi-email-edit',
    label: 'Contact Us'
  }]

  bottomMenu = [{
    path: '/main',
    icon: 'mdi-view-dashboard',
    label: 'Explore'
  },
  {
    path: '/portfolio',
    icon: 'mdi-wallet',
    label: 'Portfolio'
  },
  {
    path: '/notifications',
    icon: 'mdi-bell',
    label: 'Notifications'
  },
  {
    path: '/account',
    icon: 'mdi-account',
    label: 'Account'
  }]

  created() {
    this.$vuetify.theme.dark = true
  }

  async logout() {
    await this.authService.logout()
    this.$router.push('/login')
  }
}
